import React from "react";

import { useTranslation } from "react-i18next";

import Button, { Color } from "../../../Form/Button";
import { BoxButton } from "./styles";

interface ChangeImageButtonProps {
  onRemove: () => void;
  onEdit: () => void;
}

const ChangeImageButton: React.FC<ChangeImageButtonProps> = ({ onRemove, onEdit }) => {
  const { t: translate } = useTranslation();

  return (
    <BoxButton>
      <Button customColor={Color.TEXT_INFO} onClick={onRemove}>
        {translate("remove")}
      </Button>
      <Button customColor={Color.SECONDARY_DARK} onClick={onEdit}>
        {translate("editPhoto")}
      </Button>
    </BoxButton>
  );
};

export default ChangeImageButton;
